import RichLoader from "./Common/RichLoader";

export default function Loader() {
  return <RichLoader variant="page" />;
}
